export const ROLE_STUDENT = 'Student';
export const ROLE_TEACHER = 'Teacher';
export const ROLE_TUTOR = 'Tutor';
export const ROLE_GUARDIAN = 'Guardian';
export const ROLE_ADMIN = 'Admin';
